<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        积分商城
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;margin-bottom: 20px;">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">商品名称:</div>
          </el-col>
          <el-col :span="5">
            <el-input v-model="product"  size="small" placeholder="商品名称"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">分类:</div>
          </el-col>
          <el-col :span="5">
            <template>
              <el-select size="small" v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.cate_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-col>

          <el-col :span="8" align="center">
            <div @click="wipe()" class="wipe">清空</div>
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column label width="40" v-model="select" type="selection"></el-table-column>
        <el-table-column prop="title" width="160" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="item_no" label="货号" align="center"></el-table-column>
        <el-table-column prop="selling_price" label="价格" align="center"></el-table-column>
        <el-table-column prop="classification" width="170" label="分类" align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope">
            <button
              class="button1"
              @click="dialogFormVisible1 = true ,addMiao1(scope.row.id) "
            >添加到积分商城</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="4" style="padding-left:10px;">
            <el-checkbox v-model="selectAll" style="line-height: 34px">全选</el-checkbox>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="16">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 添加到秒杀 -->
    <el-dialog title="添加到积分商城" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="所需积分:">
          <el-input style="width:356px" v-model="integral" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="出售数量:">
          <el-input style="width:356px" v-model="number" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="addMiao()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return { serve: this.$store.state.serve,
      number: "",
      integral: "",
      product_id: "",
      msg: "",

      number: "",
      rush_price: "",
      order_by: "",
      limit: "",
      id: this.$route.query.id,
      value: "",
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      product: "",
      options: [
        
      ],

      value2: true,
      dialogFormVisible1: false,
      resType: null,
      select: false,
      selectAll: false,
      checked: []
    };
  },
  created() {
    this.$store.state.topActiveId = 5;
    this.$store.state.leftTitle = '积分商城';
    this.geting();
    this.classify()
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    classify(){
      this.axios.get(this.serve+'/admin/get_cate_name',{
        params:{
          username : this.username,
          token : this.token
        }
      }).then(res=>{
        if(res.data.status == 'success'){
          this.options = res.data.data
        }
      })
    },
    addMiao1(id) {
      this.product_id = id;
    },
    addMiao() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("product_id", this.product_id);
      formData.append("integral", this.integral);
      formData.append("number", this.number);
      this.axios
        .post(this.serve+"/admin/integral_product", formData, config)
        .then(res => {
          this.msg = res.data.msg;
          if (res.data.status == "success") {
            this.integral = '' ;
            this.number = '';
            this.dialogFormVisible1 = false;
            this.open();
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          } else if (res.data.status == "error") {
            this.dialogFormVisible1 = true;
            this.open4();
          }
        });
    },

    open4() {
      //错误时返回的息状态
      this.$message.error(this.msg);
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: this.msg,
        type: "success"
      });
    },
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },
    wipe() {
      this.value = "";
      this.product = "";
    },
    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/product_list", {
          params: {
            token: this.token,
            username: this.username,
            page,
            product: this.product,
            category: this.value
          }
        })
        .then(res => {
          that.tableData = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            that.total = res.data.data.total;
            that.page = res.data.data.page;

            for (var key in json.results) {
              that.tableData.push(json.results[key]);
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .wipe {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 160px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .wipe:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>